
const apiVersion='v1';

export const API_PATH=`/api/${apiVersion}`;
export const API_URL=`https://nypp.nypp-np.maximus.com${API_PATH}`;
export const API_PROFILE_PATH=`${API_PATH}/physician/profile/`;

